import { serverHttp } from "@/plugins/axios";

export const plans = function(params: object) {
    return serverHttp.get("/api/portal/plans", {
        params: params
    });
};
